import { useContext } from 'react';
import { FordRidesContext } from '../../../../contexts/ford-rides-context/ford-rides-context';

const useFordRidesContext = () => {
    const fordRidesContext = useContext(FordRidesContext);
    if (!fordRidesContext) {
        throw Error('ford rides context has to be used inside provider');
    }
    return fordRidesContext;
};

export default useFordRidesContext;
